module.exports = __webpack_public_path__ + "b9e675030bb7c5badb396e44d27a2dd4.png";